import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useLocation, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
  Modal,
} from "reactstrap"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"
import UgiftEmptyState from "./UgiftEmptyState"
import emptyImage from "assets/images/ugifts/icons/empty/empty_friend.png"
import emptyWechat from "assets/images/ugifts/icons/empty/empty_wechat.png"

// import images
import iconPaymentSuccess from "assets/images/ugifts/icons/checkout/icon_payment_success.png"
import iconPaymentFailed from "assets/images/ugifts/icons/checkout/icon_payment_failed.png"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

function isWechat() {
  if (
    navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1 ||
    typeof navigator.wxuserAgent !== "undefined"
  ) {
    return true
  } else return false
}

const PrivacyPolicy = () => {
  const query = useQuery()
  const history = useHistory()
  const isWechatBrowser = isWechat()

  const [token, setToken] = useState(null)

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Privacy Policy | Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  paddingTop: "56px",
                  backgroundColor: "white",
                  // paddingBottom: "76px",
                }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    {
                      <Row
                        className="m-0 w-100"
                        style={{
                          height: "56px",
                          backgroundColor: "#009FE2",
                          position: "fixed",
                          top: 0,
                          zIndex: 1030,
                          maxWidth: "480px",
                        }}
                      >
                        <Col xs={2} className="ps-0">
                          {/* <Link to="/categories"> */}
                          {/* <Button
                          className="h-100 m-0"
                          onClick={() => {
                            history.goBack()
                          }}
                        >
                          <i className="bx bx-arrow-back align-middle font-size-20 text-white" />
                        </Button> */}
                          {/* </Link> */}
                        </Col>
                        <Col xs={8} className="align-self-center">
                          <p className="h-100 text-white font-size-15 my-auto text-center">
                            {"PRIVACY AND PERSONAL DATA PROTECTION POLICY"}
                          </p>
                        </Col>
                        <Col xs={2} className="pe-0">
                          {/* <Link to="#">
                          <Button className="h-100 m-0">
                            <i className="bx bx-basket align-middle font-size-28 text-white" />
                          </Button>
                        </Link> */}
                        </Col>
                      </Row>
                    }
                    <div className="p-3">
                      <p>
                        The security of your personal data is important to us at
                        e-Buy Information Technology. This policy describes how
                        we may collect, use, disclose, process and manage your
                        personal data.
                        <br />
                        <br />
                        Personal data means any information that relates to an
                        identifiable individual. This policy applies to any
                        individual’s personal data which is in our possession or
                        under our control. Please read the following carefully.
                        <br />
                        <br />
                        At e-Buy Information Technology, we respect your
                        concerns about privacy. This Privacy Notice (“Notice”)
                        relates to the collection of personal information,
                        information security and privacy standards applicable to
                        all users of our websites, forums and blogs (“Sites”)
                        and mobile applications (“Apps”) in the course of our
                        business activities.
                        <br />
                        <br />
                        For the purpose of this Notice, “e-Buy”, “we” and “us”
                        refer to e-Buy Information Technology (International)
                        Pte. Ltd. and its subsidiaries and affiliates, as the
                        context requires. Our privacy practices vary depending
                        on the services we provide and the country-specific
                        requirements for the countries in which we operate. For
                        some products and services, where required, we will
                        provide additional privacy notices before collecting
                        your personal information. Please read this Notice
                        carefully. If you have any questions, you may contact us
                        at dpo@e-buy.com or by the methods provided in the
                        “Contact Us” section below.
                        <br />
                        <br />
                        e-Buy provides payment products and services for
                        commercial and non-commercial enterprises. Those
                        products and services include loyalty management
                        solutions, digital campaign marketing, mobile wallet
                        payment processing, point-of-sale terminal management
                        and support, merchant accounting and funds transfer. As
                        a part of our different business, we routinely collect
                        and retain personal information about our customers and
                        the third parties with whom our customers do business.
                        For our customers, information about disclosures,
                        transfers and other processing of personal information
                        as part of our payment processing function is set out in
                        the documentation provided to them at or before
                        onboarding and is outside of the scope of this Notice,
                        which relates only to information we collect through our
                        own apps and internet portals.
                        <br />
                        <br />
                        <strong>Personal Information We Collect</strong>
                        <br />
                        We collect personal data about individuals from various
                        sources described below. Where applicable, we indicate
                        whether and why individuals must provide us with
                        personal data, as well as the consequences of failing to
                        do so.
                        <br />
                        <br />
                        <i>
                          Information that we collect directly from individuals
                          and the parties with which we do business
                        </i>
                        <br />
                        We may collect personal data directly from individuals
                        and the parties with which we do business, including
                        prospects. These may include parties that interact with
                        us directly (such as individuals who download our mobile
                        applications or job applicants), parties to which we
                        provide goods or services (such as clients, banks or
                        financial institutions, merchants, and individuals)
                        (collectively, “ clients ”), parties that provide
                        services to us (such as vendors) (collectively,
                        “ service providers ”), and other parties with whom we
                        offer or provide products and services (such as
                        independent sales organizations) (collectively,
                        “ partners ”).
                        <br />
                        <br />
                        We may collect information from these parties in a
                        variety of contexts, such as when completing one of our
                        online forms, making an application for one of our
                        products or services, interacting with us on social
                        media, or corresponding with us. The types of
                        information we obtain in these contexts include:
                        <br />
                        <ul>
                          <li>
                            Contact information of the business entity and its
                            personnel who interact with us, such as name, job
                            title, address, telephone number, and email address{" "}
                          </li>
                          <li>
                            Profile information, such as username and password
                            that an individual may establish on one of our
                            websites or mobile applications, along with any
                            other information that an individual enters into
                            their account profile
                          </li>
                          <li>
                            Demographic details, such as date of birth, country
                            of citizenship and/or country of residence
                          </li>
                          <li>
                            Information about individuals’ affiliation with a
                            legal entity, such as an individual’s role, and
                            whether he or she is a beneficial owner or
                            authorized signatory
                          </li>
                          <li>
                            Government-issued identification numbers (to the
                            extent permitted under applicable law), such as a
                            national identification number (e.g., a NRIC Number
                            or passport number), or local identification number
                            (e.g., other government-issued identification
                            number), and a copy of your government-issued
                            identification card
                          </li>
                          <li>
                            Feedback and correspondence, such as information you
                            provide when you request information from us,
                            receive customer support, or otherwise correspond
                            with us, including by interacting with our pages on
                            social networking online sites or services
                          </li>
                          <li>
                            Financial account information, such as payment card
                            or bank account details for our merchants,
                            customers, suppliers and staff.
                          </li>
                          <li>
                            Information about merchants, such as merchant name,
                            merchant ID and category code, merchant location
                            where a transaction occurred, and information about
                            transactions processed by the merchant, including
                            transaction volume, velocity, amounts, types of
                            goods or services sold, and chargeback ratios
                          </li>
                          <li>
                            Information related to the use of E-Buy Information
                            Technology products or services, such as account
                            information, spending thresholds, spending activity
                            and patterns, and information about the transactions
                            we process
                          </li>
                          <li>
                            Precise geolocation information, if you authorize
                            our mobile application to access your location
                          </li>
                          <li>
                            Marketing information, such as your preferences for
                            receiving marketing communications and details about
                            how you engage with our marketing communications
                          </li>
                          <li>
                            Other information supplied by job applicants, such
                            as professional credentials and skills, educational
                            and work history, and other information of the type
                            included on a resume or curriculum vitae
                          </li>
                        </ul>
                        <br />
                        <i>
                          Information that we collect about individuals who do
                          not interact with us directly
                        </i>
                        <br />
                        We may receive personal data about individuals who do
                        not interact with us directly. For example, our clients,
                        service providers, and partners may provide us with
                        information about individuals other than themselves when
                        using our products or services. In addition, due to the
                        unique nature of E-Buy’s business, in many cases, E-Buy
                        Information Technology obtains personal data from other
                        participants in a transaction processing chain, such as
                        card associations, debit network operators, online
                        wallet operators, bank loyalty schemes, airline loyalty
                        schemes, telco companies loyalty scheme, and their
                        members. The types of information we receive about third
                        parties includes:
                        <br />
                        <ul>
                          <li>
                            <strong>
                              Information about the personnel of our clients,
                              service providers, or partners
                            </strong>
                             , such as the business contact information that our
                            clients, service providers, or partners provide to
                            us in the context of our contractual relationships
                            with them
                          </li>
                          <li>
                            <strong>
                              Information about potential job candidates
                            </strong>
                             , such as when a recruiter contacts us about an
                            individual who may become a candidate for a job at
                            e-Buy
                          </li>
                          <li>
                            <strong>
                              Information about customers of our clients
                            </strong>
                             that our clients send to us or allow us to collect
                            in the context of the services that E-Buy
                            Information Technology performs, such as information
                            related to financial transactions initiated by the
                            customer, account registrations, and in some cases
                            information needed to verify a customer’s identity
                            and details of products or services purchased, and
                            as otherwise stated in an applicable specific
                            privacy notice for a E-Buy Information Technology
                            product or service. Where our technology is
                            incorporated into a merchant’s mobile application or
                            website, we also may automatically collect certain
                            information of the type described in the section
                            below titled “Information collected via automated
                            means.”
                          </li>
                          <li>
                            <strong>
                              Information obtained when processing transactions
                            </strong>
                            , such as information about payment transactions
                          </li>
                        </ul>
                        <i>
                          Information we collect from private and publicly
                          accessible sources
                        </i>
                        <br />
                        We and our service providers may collect information
                        about individuals that is publicly available, including
                        by searching publicly accessible government lists of
                        restricted or sanctioned persons (such as the Specially
                        Designated Nationals And Blocked Persons List), public
                        records databases (such as company registries and
                        regulatory filings), and by searching media and the
                        internet. We and or our third party verification
                        providers may also collect information from private or
                        commercially available sources, such as by requesting
                        reports or information from credit reference and fraud
                        prevention agencies, to the extent permitted under
                        applicable law.
                        <br />
                        <br />
                        We may also maintain pages for our company and our
                        products and services on a variety of third-party
                        platforms, such as LinkedIn, Facebook, Twitter, Google+,
                        YouTube, Instagram, WeChat, QQ and other social
                        networking services. When you interact with our pages on
                        those third-party platforms, the third-party’s privacy
                        policy will govern your interactions on the relevant
                        platform. If the third-party platform provides us with
                        information about our pages on those platforms or your
                        interactions with them, we will treat that information
                        in accordance with this Privacy Notice.
                        <br />
                        <br />
                        <i>Information collected via automated means</i>
                        <br />
                        When you access our websites or use our mobile
                        applications, we, our service providers, and our
                        partners may automatically collect information about
                        you, your computer or mobile device, and activity on our
                        websites or mobile applications. Typically, this
                        information includes your computer or mobile device
                        operating system type and version number, manufacturer
                        and model, device identifier (such as the Google
                        Advertising ID or Apple ID for Advertising), browser
                        type, screen resolution, IP address, the website you
                        visited before browsing to our website, general location
                        information such as city, state or geographic area; and
                        information about your use of and actions on or in our
                        websites or mobile applications, such as pages or
                        screens you accessed, how long you spent on a page or
                        screen, navigation paths between pages or screens,
                        information about your activity on a page or screen,
                        access times, and length of access. Certain products or
                        services that we provide or which merchants may
                        incorporate into their websites or mobile applications
                        may automatically collect additional information, as may
                        be further described in a separate privacy notice.
                        <br />
                        <br />
                        Our service providers and business partners may collect
                        this type of information over time and across
                        third-party websites. This information is collected via
                        various mechanisms, such as via cookies, web beacons,
                        embedded scripts, through our mobile applications, and
                        similar technologies. This type of information may also
                        be collected when you read our HTML-enabled emails.
                        Please refer to our Cookies Disclosure for more details.
                        You can choose to disable cookies or to opt out of the
                        use of your browsing behavior for purposes of targeted
                        advertising. For opt out instructions, please review the
                        “ Targeted online advertising ” portion of the “Your
                        Choices” section of this Privacy Notice.
                        <br />
                        <br />
                        <i>Sensitive personal data</i>
                        <br />
                        In limited circumstances and when permitted by law, in
                        the context of processing employment applications, we
                        may also request sensitive information, such as racial
                        or ethnic origin or information about disability, where
                        required or permitted by law of the country in which you
                        are applying for employment.
                        <br />
                        Outside of these contexts or otherwise as we
                        specifically request, we ask that you not provide us
                        with any sensitive personal data (meaning information
                        revealing racial or ethnic origin, political opinions,
                        religion or philosophical beliefs, trade union
                        membership, genetic, health, or biometric information,
                        information about sex life or sexual orientation, or
                        criminal convictions or offenses) through our websites
                        or mobile applications, or otherwise to us.
                        <br />
                        <br />
                        <strong>Sources of Personal Information</strong>
                        <br />
                        We collect personal information that you provide to us
                        when you visit our Sites or Apps, set up an account with
                        us, communicate with us, or otherwise enter into a
                        contractual arrangement with us. We may also collect
                        information about you from third parties. For example,
                        we may receive referrals from banks or independent
                        service organizations with which you have a
                        relationship. In addition, when you visit our Sites we
                        may collect certain information about your location,
                        usage, or device through technology such as cookies (see
                        “Cookies and Other Tracking Technologies” below).
                        <br />
                        <br />
                        <strong>
                          How We Use the Personal Information We Obtain{" "}
                        </strong>
                        <br />
                        Subject to your consent if required by law, we may use
                        your personal information for the following business
                        purposes:
                        <ul>
                          <li>
                            contact you regarding any inquiry you make or to
                            fulfill a request, such as, for example, a request
                            for information about our products and services;{" "}
                          </li>
                          <li>
                            To improve and personalize your experience when you
                            use our Sites;
                          </li>
                          <li>
                            To improve our products and services and for the
                            development of future products and services;
                          </li>
                          <li>
                            For internal record keeping and administration of
                            records;
                          </li>
                          <li>
                            For auditing related to a current interaction with
                            the consumer and concurrent transactions, including,
                            but not limited to, counting ad impressions to
                            unique visitors, verifying positioning and quality
                            of ad impressions, and auditing compliance with laws
                            and other standards;
                          </li>
                          <li>
                            For detecting security incidents, protecting against
                            malicious, deceptive, fraudulent, or illegal
                            activity, and prosecuting those responsible for that
                            activity
                          </li>
                          <li>
                            For internal research for technological development
                            and demonstration;
                          </li>
                          <li>
                            To verify or maintain the quality or safety of our
                            products and services and to improve, upgrade, or
                            enhance our services;
                          </li>
                          <li>
                            To contact you by email and, if you have signed up
                            for the service, to share e-newsletter or any other
                            updates, communications or publications;
                          </li>
                          <li>
                            For direct marketing purposes subject to your
                            consent if required by applicable law (see “Managing
                            Your Preferences” below);
                          </li>
                          <li>
                            As necessary to set up and administer your sign up
                            to, and use of, the log in facility available on the
                            Sites; and
                          </li>
                          <li>
                            For compliance with applicable laws and/or
                            regulations and as otherwise required or permitted
                            by applicable laws and/or regulations.
                          </li>
                        </ul>
                        <br />
                        <i>
                          Providing our products and services, which includes:{" "}
                        </i>
                        <ul>
                          <li>
                            Operating, evaluating, maintaining, improving, and
                            providing the features and functionality of our
                            products and services;
                          </li>
                          <li>
                            Fulfilling a payment transaction initiated by you
                            (either with us, our client, our merchant)
                          </li>
                          <li>
                            Managing our relationship with you or your company;
                          </li>
                          <li>
                            Carrying out our obligations, and exercising our
                            rights, under our agreement with you or your
                            company;
                          </li>
                          <li>
                            Communicating with you regarding your account with
                            us, if you have one, including by sending you
                            service-related emails or messages (e.g., messages
                            regarding account verification, changes or updates
                            to the functionality of our products or services,
                            technical and security notices and alerts, and
                            support and administrative messages);
                          </li>
                          <li>
                            Personalizing the manner in which we provide our
                            products and services;
                          </li>
                          <li>
                            Checking for fraud or money laundering and/or
                            managing either our or our clients’ risk
                          </li>
                          <li>
                            Administering and protecting our business; and
                          </li>
                          <li>
                            Providing support and maintenance for our products
                            and services, including responding to your
                            service-related requests, questions, and feedback.
                          </li>
                        </ul>
                        <br />
                        <i>For research and development</i>
                        We use the information we collect for our own research
                        and development purposes, which include:
                        <ul>
                          <li>
                            Developing or improving our products and services
                          </li>
                          <li>
                            Developing and creating analytics and related
                            reporting, such as regarding industry and fraud
                            trends{" "}
                          </li>
                        </ul>
                        <br />
                        <i>Marketing</i>
                        We may use your personal data to form a view on what
                        products or services we think you may want or need, or
                        what may be of interest to you.
                        <br />
                        <br />
                        We may contact you with marketing communications using
                        the personal data you have provided to us if you have
                        actively expressed your interest in making a purchase or
                        have made a purchase from us and, in any case, you have
                        not opted out of receiving that marketing, to the extent
                        permitted by applicable law.
                        <br />
                        Where required by law, we will get your express opt-in
                        consent before we share your personal data with any
                        company outside the E-Buy Information Technology group
                        for marketing purposes.
                        <br />
                        <br />
                        <strong>
                          How we Share the Personal Information We Collect{" "}
                        </strong>
                        We are a multinational business headquartered in the
                        Hong Kong (with the ultimate parent based in Shanghai,
                        China,) with subsidiaries and affiliates in various
                        countries around the world. Your personal information
                        may be disclosed to recipients located outside of your
                        country, including our global subsidiaries and
                        affiliates (see “Our Relationship with Affiliate
                        Companies” below), as well as other types of service
                        providers engaged to help us run our business, subject
                        to your consent if required by law. These types of
                        service providers may include distributors of our
                        products and services, vendors retained to perform
                        functions on our behalf or to provide services to us,
                        including (without limitation) legal, accounting, audit,
                        consulting and other professional service providers, and
                        providers of other services related to our business.
                        <br />
                        In addition, if you were referred to e-Buy for services
                        via a partner, such as independent services
                        organization, we may share information with such partner
                        in accordance with our business relationship with you
                        and that partner, consistent with any privacy notice
                        shared with you by either party at the time of the
                        collection of your personal information.
                        <br />
                        We take steps aimed at ensuring that all persons who
                        process your personal information as a service provider
                        to us process such information only as necessary for
                        their service delivery and, where required by law, we
                        ensure appropriate written instruction is provided to
                        each service provider.
                        <br />
                        We may also disclose your personal information to third
                        parties who are not service providers. For each category
                        of personal information we collect, we may share such
                        information with the following categories of third
                        parties for the business purpose described :
                        <ul>
                          <li>
                            To regulators including state and federal agencies,
                            card payment networks, issuing banks and other
                            parties required to enable compliance with laws,
                            regulations and industry standards related to
                            transaction processing in order to obtain commercial
                            and credit information to establish, maintain or
                            renew a customer’s contract(s), as may be required
                            to provide any of the services for which a customer
                            has subscribed, to comply with the rules and
                            regulations of any credit or debit card payment
                            network or otherwise in accordance with this policy;
                          </li>
                          <li>
                            To law enforcement, courts and other relevant
                            parties in response to a court order or a request
                            for cooperation from a regulatory, law enforcement
                            or other government agency; to establish or exercise
                            our legal rights; to defend legal claims; as
                            otherwise required or permitted by applicable laws
                            and/or regulations; when we believe that disclosure
                            is appropriate in connection with efforts to
                            investigate, prevent, or take action regarding
                            actual or suspected illegal activity, fraud, or
                            other wrongdoing; or to protect and defend the
                            rights, property or safety of e-Buy, its customers,
                            staff, suppliers or others; and
                          </li>
                          <li>
                            Subject to applicable legal requirements, to another
                            company or agent of such company in connection with
                            or during negotiation of any merger, financing,
                            acquisition, bankruptcy, dissolution, transaction or
                            proceeding involving sale, transfer, divestiture, or
                            disclosure of all or a portion of our business
                            assets to such company.
                          </li>
                        </ul>
                        Unless otherwise disclosed in a specific notice, and
                        subject to your consent where required by applicable
                        law,, we do not sell your personal information to third
                        parties.
                        <br />
                        <strong>
                          Our Relationship with Affiliate Companies (Including
                          Sharing and Cross-Border Transfers){" "}
                        </strong>
                        <br />
                        Subject to your consent if required by applicable law,
                        we may appoint an affiliate company to process personal
                        information in a service provider role. In most cases,
                        we will remain responsible for that company’s processing
                        of your personal information pursuant to applicable data
                        privacy laws.
                        <br />
                        Because our affiliate companies are located around the
                        globe, your personal information is currently stored in
                        Singapore and may be transferred to \e Hong Kong or in
                        another country outside of the country in which you
                        reside, which may be subject to different standards of
                        data protection than your country of residence.
                        <br />
                        We take appropriate steps to ensure that transfers of
                        personal information are in accordance with applicable
                        law, are carefully managed to protect your privacy
                        rights and interests and limited to countries which are
                        recognized as providing an adequate level of legal
                        protection or where alternative adequate arrangements
                        are in place to protect your privacy rights
                        <br />
                        <strong>Login Details and Your Responsibility </strong>
                        <br />
                        Subject to your consent if required by applicable law,
                        we will collect and process your personal information as
                        necessary to set up and administer your sign up to, and
                        use of, the log in facility available on our Sites and
                        Apps. We will use “cookies” to “remember” the machine or
                        other device you use to access our Sites and Apps (see
                        “Cookies and Other Tracking Technologies” below). Please
                        remember that if we contact you, we will never ask you
                        for your password in an unsolicited email, message or
                        phone call. If you choose to use the log in facility
                        available on our Sites, you are required to adhere to
                        the following security procedures in relation to your
                        username (currently, your email address) and password,
                        which are referred to as “login information”:
                        <br />
                        <ul>
                          <li>
                            Keep your login information secret and secure at all
                            times and do not disclose it to any other person or
                            allow any other person to use it;
                          </li>
                          <li>
                            Do not write down or record in any form your login
                            information or store it on any software, including a
                            password save feature;
                          </li>
                          <li>
                            Destroy any notice from us concerning your login
                            information as soon as you have read and understood
                            it;
                          </li>
                          <li>
                            Should you become aware or have reason to suspect
                            that your login information has been lost or
                            disclosed to, or seen or accessed by someone other
                            than yourself, immediately notify E-Buy at the email
                            address provided above;
                          </li>
                          <li>
                            Do not leave your computer or other device
                            unattended while you are using the log in facility
                            available on this website or let anyone else use
                            your computer or other device unless and until you
                            have logged out; and
                          </li>
                          <li>
                            Use particular caution if you access the log in
                            facility available on our Sites from a public or
                            shared computer, to ensure that other people are not
                            able to see your login details.
                          </li>
                        </ul>
                        <br />
                        <strong>Data Anonymization and Aggregation </strong>
                        <br />
                        Subject to your consent if required by law, we may
                        anonymize or aggregate your personal information in such
                        a way as to ensure that you are not identified or
                        identifiable from it, in order to use the anonymized or
                        aggregated data, for example, for statistical analysis
                        and administration including analysis of trends, to
                        carry out actuarial work, to tailor products and
                        services and to conduct risk assessments and analysis of
                        costs and charges in relation to our products and
                        services. We may share anonymized or aggregated data
                        with our global affiliates and with other third parties.
                        This Notice does not restrict e-Buy's use or sharing of
                        any non-personal, summarized, derived, anonymized or
                        aggregated information.
                        <br />
                        <br />
                        <strong>
                          Commitment to Security, Privacy and Standards{" "}
                        </strong>
                        <br />
                        We take seriously our responsibility to protect the
                        security and privacy of the information we receive via
                        our Sites and Apps. We maintain administrative,
                        technical and physical safeguards designed to protect
                        the personal information you provide via our Sites and
                        Apps against accidental, unlawful or unauthorized
                        destruction, loss, alteration, access, disclosure or
                        use.
                        <br />
                        Please remember that communications over the internet
                        such as emails are not secure. We seek to keep secure
                        all confidential information and personal information
                        submitted to us through our Sites in accordance with our
                        obligations under applicable laws and regulations.
                        However, like all website operators, we cannot guarantee
                        the security of any data transmitted through our Sites.
                        <br />
                        <br />
                        <strong>
                          Cookies and Other Tracking Technologies{" "}
                        </strong>
                        <br />
                        A “cookie” is a text file that websites send to a
                        visitor’s computer or other internet-connected device to
                        uniquely identify the visitor’s browser or to store
                        information or settings in the browser. Some of our
                        Sites use cookies including cookies that are strictly
                        necessary to enable the features of our Sites,
                        performance cookies to see how visitors use our Sites,
                        and functionality cookies that enable the Sites to
                        “remember” machines or devices, personalize website
                        content and tailor user experience.
                        <br />
                        On some Sites we also use cookies to help us target
                        advertisements to users when they are browsing this
                        website and other websites, in each case by reference to
                        anonymous identifiers, not personal information.
                        <br />
                        In addition to the cookies e-Buy sets when you visit our
                        Sites, third parties may also set cookies when you visit
                        e-Buy sites. In some cases, that is because we have
                        hired the third party to provide services on our behalf,
                        such as site analytics. In other cases, it is because
                        our web pages contain content from third parties, such
                        as videos, news content or ads delivered by ad networks.
                        Because your browser connects to those third parties’
                        web servers to retrieve that content, those third
                        parties are able to set or read their own cookies on
                        your device and may collect information about your
                        online activities across websites or online services.
                        Our Cookie Statement provides additional information
                        about the cookies on this page and about your options to
                        opt-out of third-party cookies.
                        <br />
                        <br />
                        <strong>External Links </strong>
                        <br />
                        E-Buy may provide links on our Sites to other websites
                        that are not under our control. We do not endorse or
                        make any warranty of any type regarding the content
                        contained on such websites or products and services
                        offered on those websites. We make no representation
                        regarding your use of such websites. Please be aware
                        that we are not responsible for the privacy practices of
                        the operators of other websites. We encourage our users
                        to be aware when they leave our Sites and to read the
                        privacy statements of each and every website that
                        collects personal information. This Notice applies
                        solely to information collected by us. You should read
                        any other applicable privacy and cookies notices
                        carefully before accessing and using such other
                        websites.
                        <br />
                        <br />
                        <strong>Changes and Updates </strong>
                        <br />
                        We reserve the right, in our sole discretion, to amend
                        or modify this Policy from time to time in response to
                        legislative changes applicable to us or to be consistent
                        to the way we use your personal data.
                        <br />
                        <br />
                        <strong>Choice of Law </strong>
                        <br />
                        This Notice, including all revisions and amendments
                        thereto, is governed by the laws of Singapore, without
                        regard to its conflict or choice of law principles which
                        would require application of the laws of another
                        jurisdiction.
                        <br />
                        <br />
                        <strong>Contact Us</strong>
                        <br />
                        If you have questions about this Notice, or if you want
                        to exercise your rights as described in this Notice, you
                        you can contact us as follows:
                        <br />
                        E-Buy Information Technology (International) Pte. Ltd.
                        <br />
                        138 Robinson Road
                        <br />
                        Unit 06-03 Oxley Tower
                        <br />
                        Singapore 068906​
                        <br />
                        dpo@e-buy.com
                        <br />
                        <br />
                        In order to honor any access or deletion request, we
                        will require you to provide enough information for us to
                        verify your identity. For example, we may ask you for
                        information associated with your account, including your
                        contact information or other identifying information. If
                        you designate an authorized agent to make a rights
                        request on your behalf, we may require proper proof of
                        that authorization as well as direct verification of
                        your identity from you.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PrivacyPolicy
